<div class="promote-plan-container">
    <div class="utrade-logo flex-centered-container-hr margin-8-bottom ">
        <img src="/assets/icons/logo-compact.png" class="margin-right " />
    </div>
    <div class="promote-plan-content margin-8-bottom">
        <div class="padding-bottom ">
            <div class="font-20 plans-text">{{brokerPlanInfo.plan_name}} Plan <span *ngIf="frequency" class="font-16"> ({{ frequency }}) </span></div>
        </div>

        <div class=margin-bottom>

            <div class="font-18 font-bold margin-8-bottom">
                <span> Rs 0</span>
                <span class="placeholder-text font-12"> +</span>
                <span *ngIf="discount" class="dynamic-font-12 strike-through placeholder-text ">
                    <span> {{brokerage_value}}</span>
                </span>
                <span class="font-12 pad-8-top">
                    {{discounted_brokerage_value}} Brokerage
                </span>
            </div>

            <div class="plans-text font-12">
                {{promotionPlanCaption}}
            </div>
        </div>
        <div class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text no-border">
            <mat-icon [svgIcon]="getTick(brokerPlanInfo.live_trading)" class="margin-8-right"></mat-icon>
            Live Deployment
        </div>
        <div class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text">
            <mat-icon [svgIcon]="getTickByAlgoPermissions(AlgoPermissionMapping['uTrade Originals'])"
                class="margin-8-right"></mat-icon>
            uTrade Originals
        </div>
        <div *ngIf="symbolsMap.get(Exchange.NSE)" class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text">
            <mat-icon [svgIcon]="getTick(true)" class="margin-8-right"></mat-icon>
           <div #NSESymbols class="promote-plan-symbols" [ngClass]="{'overflow-ellipsis':showNseEllipsis}" (click)="toggleEllipsis(true,NSESymbols)">NSE: {{symbolsMap.get(Exchange.NSE)}}</div> 
        </div>
        <div *ngIf="symbolsMap.get(Exchange.BSE)" class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text">
            <mat-icon [svgIcon]="getTick(true)" class="margin-8-right"></mat-icon>
            <div #BSESymbols class="promote-plan-symbols" [ngClass]="{'overflow-ellipsis':showBseEllipsis}" (click)="toggleEllipsis(false,BSESymbols)">BSE: {{symbolsMap.get(Exchange.BSE)}}</div>
        </div>
        <div class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text">
            <mat-icon [svgIcon]="getTick(brokerPlanInfo.max_active_algo > 0)" class="margin-8-right"></mat-icon>
            {{brokerPlanInfo.max_active_algo > 0 ? "Get " + brokerPlanInfo.max_active_algo : ''}} Concurrent algo
            deployment
        </div>
        <div class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text">
            <mat-icon [svgIcon]="getTick(!!brokerPlanInfo.max_multiplier)" class="margin-8-right"></mat-icon>
            Get upto {{brokerPlanInfo.max_multiplier}}X Multiplier for uTrade Originals
        </div>
        <div class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text">
            <mat-icon [svgIcon]="getTick(brokerPlanInfo.max_saved_algo > 0)" class="margin-8-right"></mat-icon>
            Strategy Creation
        </div>
        <div class="pad-8-vr font-14 mat-icon-16 display-flex align-items-center plans-feature-text">
            <mat-icon [svgIcon]="getTickByAlgoPermissions(AlgoPermissionMapping['Relationship Manager'])"
                class="margin-8-right"></mat-icon>
            Personalized RM
        </div>
    </div>

    <div class="connect-broker font-12 placeholder-text" *ngIf="!isShareIndia">
        Connect to Broker or create an account at Shareindia to access this plan.
    </div>
    <div class="promote-plan-buttons display-flex-column align-items-center">
        <button mat-flat-button class="ut-pro-button gradient margin-vr full-width" tabindex="-1"
            color="accent" (click)="subscribePlan()">
            {{isShareIndia? 'Subscribe Now' : 'Connect Now'}}
        </button>
        <div class="decoration-underline cursor-pointer font-14" (click)="closeDialog()">
            Skip for Now
        </div>
    </div>
</div>